import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { FaDirectiveEnum } from '../../../../models/enums/fa-directive.enum';
import { NgForOf, NgIf } from '@angular/common';
import { BaryIconComponent } from '../bary-icon/bary-icon.component';
import { CdkDrag, CdkDragDrop, CdkDropList, moveItemInArray } from '@angular/cdk/drag-drop';

@Component({
  selector: 'jhi-bary-sortable-list',
  templateUrl: './bary-sortable-list.component.html',
  styleUrls: ['./bary-sortable-list.component.scss'],
  standalone: true,
  imports: [NgIf, NgForOf, BaryIconComponent, CdkDropList, CdkDrag],
})
export class BarySortableListComponent {
  @Input() items: any[] = [];
  @Input() labelField!: string;
  @Input() showPosition = false;

  @ViewChild('listGroup') listGroup!: ElementRef;

  protected readonly FAS = FaDirectiveEnum.FAS;

  public getItems(): any[] {
    return this.items;
  }

  public getItemLabel(item: any): string {
    if (item instanceof AbstractControl) {
      return item.value[this.labelField] as string;
    } else {
      return item[this.labelField] as string;
    }
  }

  public drop(event: CdkDragDrop<any>): void {
    moveItemInArray(this.items, event.previousIndex, event.currentIndex);
  }
}
